import { Box, Button, FormControl, TextField, Typography, Snackbar, Alert, IconButton, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
function LoginForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const navToRegister = () => {
        navigate('/register');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            await signInWithEmailAndPassword(auth, email, password);
            setAlertMessage("Connexion réussie !");
            setAlertType("success");
            setOpenSnackbar(true);
            navigate('/');
        } catch (error) {
            setAlertMessage('Email ou mot de passe incorrect');
            setAlertType('error');
            setOpenSnackbar(true);
        }
    };

    const handleResetPassword = async () => {
        if (!email) {
            setAlertMessage('Veuillez entrer un email pour réinitialiser le mot de passe');
            setAlertType('warning');
            setOpenSnackbar(true);
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            setAlertMessage('Email de réinitialisation envoyé !');
            setAlertType('success');
            setOpenSnackbar(true);
        } catch (error) {
            setAlertMessage('Erreur lors de l\'envoi de l\'email de réinitialisation');
            setAlertType('error');
            setOpenSnackbar(true);
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev); // Bascule la visibilité du mot de passe
    };
    return (
        <>
            <Box sx={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#121212', // Fond noir élégant
                padding: '2rem'
            }}>
                <Typography sx={{ fontFamily: 'SUSE, sans-serif', color: 'white', mb: 4 }} variant="h4">Se connecter</Typography>

                <FormControl onSubmit={handleSubmit} sx={{
                    backgroundColor: '#1e1e1e',  // Fond plus sombre pour le formulaire
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',  // Effet d'ombre pour plus de relief
                    width: '100%',
                    maxWidth: '400px'
                }}>
                    <TextField sx={{
                        mt: 2,
                        '& .MuiInputBase-root': { color: 'white' },
                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#555'
                        },
                        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#888'
                        },
                        '& .MuiInputLabel-root': { color: '#aaa' },
                    }} InputLabelProps={{ style: { color: 'white', fontFamily: 'SUSE, sans-serif' } }} type="email" id="outlined-basic" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} required variant="outlined" />
                    <TextField
                        sx={{
                            mt: 2,
                            '& .MuiInputBase-root': { color: 'white' },
                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#555'
                            },
                            '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#888'
                            },
                            '& .MuiInputLabel-root': { color: '#aaa' },
                        }}
                        InputLabelProps={{ style: { color: 'white', fontFamily: 'SUSE, sans-serif' } }}
                        type={showPassword ? "text" : "password"}  // Basculer entre "password" et "text"
                        id="outlined-basic"
                        label="Mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        variant="outlined"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={togglePasswordVisibility}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff sx={{ color: 'white' }} /> : <Visibility sx={{ color: 'white' }} />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <Button sx={{ mt: 2, fontFamily: 'SUSE, sans-serif', color: 'white' }} type='submit' variant="contained" onClick={handleSubmit}>Se connecter</Button>

                    <Button sx={{ mt: 2, fontFamily: 'SUSE, sans-serif', color: 'white' }} onClick={handleResetPassword} variant="text">
                        Réinitialiser le mot de passe
                    </Button>

                    <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif', mt: 2 }} variant="body2">
                        Vous n'avez pas (encore) de compte ? <span onClick={navToRegister} style={{ color: '#1976d2', cursor: 'pointer' }}>S'inscrire</span>
                    </Typography>
                </FormControl>

                {/* Snackbar pour afficher les messages d'alerte */}
                <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={alertType} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </>
    );
}

export default LoginForm;
